// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dEg2","left":"styles_left__2w6qr"};